import trophyUrl from "../../assets/icons/trophy.svg";

export default function TrophyIcon({ size = 20, className = "" }) {
  const iconSize = typeof size === "number" ? `${size}px` : size;

  return (
    <img
      src={trophyUrl}
      alt=""
      className={className}
      aria-hidden="true"
      style={{
        width: iconSize,
        height: iconSize,
        display: "inline-block",
        verticalAlign: "-0.125em",
        flexShrink: 0,
        objectFit: "contain",
      }}
    />
  );
}
